import React, {useEffect, useRef, useState} from 'react';
import {useNavigate, useOutletContext} from 'react-router-dom';
import {Alert, Box, Button, Container, TextField, Typography} from '@mui/material';
import {Sessions} from '../../controllers';
import {CONST, TokenValidator} from '../../utils';

export default function Login() {
    const nav = useNavigate();
    const {Login: context} = useOutletContext();
    const [credential, setCredential] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const pending = useRef(false);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const token = await TokenValidator.GetStaffUser();
                if (await context.validate(token) && !cancelled) nav('/trackinglookup/main', {replace: true});
            } catch (_) { /* sign in if storage is invalid */ }
        })();
        return () => {cancelled = true;};
    }, [context, nav]);
    const submit = async event => {
        event.preventDefault();
        if (pending.current) return;
        pending.current = true; setBusy(true); setError('');
        try {
            const response = await Sessions.Direct(credential);
            if (!response?.success || !await context.validate(response.token)) {
                setError('Credencial inválida o sin permiso de Tracking Station.'); return;
            }
            localStorage.setItem(CONST.STORAGE_KEYS.STAFF_LOGIN, JSON.stringify(response.token));
            context.didLogin(true); nav('/trackinglookup/main', {replace: true});
        } catch (_) {setError('No se pudo iniciar sesión. Intenta nuevamente.');}
        finally {pending.current = false; setBusy(false);}
    };
    return <Container maxWidth='xs'><Box component='form' onSubmit={submit} sx={{mt: 8, display: 'flex', flexDirection: 'column', gap: 2}}>
        <Typography variant='h5'>Rastreo de órdenes</Typography>
        <Typography>Usa tu acceso de Tracking Station.</Typography>
        {error && <Alert severity='error'>{error}</Alert>}
        <TextField required autoFocus type='password' label='Credencial' value={credential} onChange={e=>setCredential(e.target.value)} disabled={busy} />
        <Button type='submit' variant='contained' disabled={busy}>{busy ? 'Validando…' : 'Entrar'}</Button>
    </Box></Container>;
}
